import { combineReducers } from "redux";

import Sms from "routes/Home/Attendance/SettingAttendance/Sms/reducers";
const reducers = combineReducers({
  // Assignment,
  // RulePack,
  Sms,
});

export default reducers;
